import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApplePay, Card, GooglePay, Netbanking, UPI } from '../../../assests/ExportImageIcon'
import './addMoneyWallet.css'

const QUICK_AMOUNTS = ['₹500', '₹1,000', '₹2,000', '₹5,000']

const PAYMENT_METHODS = [
    { key: 'apple', icon: ApplePay, name: 'Apple Pay', detail: 'XXXX XXXX XXXX 4532' },
    { key: 'google', icon: GooglePay, name: 'Google Pay', detail: 'john.doe@gmail.com' },
    { key: 'card', icon: Card, name: 'Credit/Debit Card', detail: 'Add new card' },
    { key: 'upi', icon: UPI, name: 'UPI', detail: 'john.@oksbi' },
    { key: 'netbanking', icon: Netbanking, name: 'Net Banking', detail: 'All Bank Supported' },
]

const BENEFITS = [
    'Instant wallet credit (no processing time)',
    'Get 2% cashback on wallet transactions',
    'Secure payments with encryption',
    'Easy refunds directly to wallet',
]

const BackArrow = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M15 9H4M8 5l-4 4 4 4" stroke="#026D4D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const AddMoneyWallet = () => {
    const navigate = useNavigate()
    const [amount, setAmount] = useState('100')
    const [selectedMethod, setSelectedMethod] = useState(null)
    const [promoCode, setPromoCode] = useState('')

    return (
        <>
            <section className='commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='commonMaxWidth'>
                                <div className='tripDocHeader' onClick={() => navigate(-1)}>
                                    <BackArrow />
                                    <span className='bsSectionTitle'>Add Money to Wallet</span>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='addMoneyWallet'>
                                <div className='left '>
                                    <div className='bsSectionTitle'>Enter Amount</div>
                                    <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='addMoneyAmountInput '>
                                        <span>₹</span>
                                        <span className='addMoneyAmountDivider' />
                                        <input
                                            type='number'
                                            placeholder='Enter Amount'
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                        />
                                    </div>

                                    <div className='addMoneyQuickAmounts'>
                                        {QUICK_AMOUNTS.map((value) => (
                                            <span
                                                key={value}
                                                className={`addMoneyAmountPill ${amount === value.replace(/[₹,]/g, '') ? 'active' : ''}`}
                                                onClick={() => setAmount(value.replace(/[₹,]/g, ''))}
                                            >
                                                {value}
                                            </span>
                                        ))}
                                    </div>
                                    </div>

                                    <div className='bsSectionTitle mt-4'>Select Payment Method</div>
                                    <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    {PAYMENT_METHODS.map((method) => (
                                        <div
                                            className='paymentSavedMethod'
                                            key={method.key}
                                            onClick={() => setSelectedMethod(method.key)}
                                        >
                                            <span className='resultCard__logo'>
                                                <img src={method.icon} alt={method.name} />
                                            </span>
                                            <div className='paymentSavedMethodInfo'>
                                                <div className='resultCard__airlineName'>{method.name}</div>
                                                <div className='paymentSavedMethodSub'>{method.detail}</div>
                                            </div>
                                            <span className={`paymentRadio ${selectedMethod === method.key ? 'checked' : ''}`} />
                                        </div>
                                    ))}
                                    </div>
                                </div>

                                <div className='right'>
                                    <div className='bsSectionTitle'>Benefits of Adding Money</div>
                                    <div className='bsBox'>
                                        <ul className='bsInfoList'>
                                            {BENEFITS.map((benefit, index) => (
                                                <li key={index}>{benefit}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className='bsSectionTitle mt-4'>Have a Promo Code?</div>
                                    <div className='bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='addMoneyPromoRow'>
                                        <input
                                            type='text'
                                            className='bsCouponInput'
                                            placeholder='Enter Promo Code'
                                            value={promoCode}
                                            onChange={(e) => setPromoCode(e.target.value)}
                                        />
                                        <button type='button' className='commonBtn addMoneyPromoBtn'>Apply</button>
                                    </div>
                                    <p className='addMoneyPromoTip'>💡 Try &quot;WALLET50&quot; for ₹50 bonus on any amount</p>
                                    </div>

                                    <div className='bsBox mt-4'>
                                        <div className='bsFareRow'>
                                            <span>Amount</span>
                                            <span>₹{amount || 0}</span>
                                        </div>
                                        <div className='bsFareRow bsFareRow--total'>
                                            <span>You&apos;ll Get</span>
                                            <span>₹{amount || 0}</span>
                                        </div>
                                        <button type='button' className='commonBtn w-100 mt-3' onClick={() => navigate('/offer-cashback')}>Add Money to Wallet</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AddMoneyWallet
